
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router: Router = inject(Router);
  const isAuthenticated = authService.isAuthenticated();
  
  console.log(`[AuthGuard] Checking route: ${state.url}. Is authenticated? ${isAuthenticated}`);

  if (authService.isAuthenticated()) {
    return true;
  }
  
  console.log(`[AuthGuard] Access denied. Redirecting to /login.`);
  return router.parseUrl('/login');
};
